import { SET_CERTIFICATE_DATA, UPDATE_PROFILE_DATA } from '../actions/profile';

let defaultState = {
    certificate: null,
    removals: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_CERTIFICATE_DATA:
      return Object.assign({}, state, { certificate: action.certificate, removals: action.removals });
    case UPDATE_PROFILE_DATA:
      return Object.assign({}, state, { user: { email: action.email } });
    default:
      return state;
  }
};
